import { Moon, Sun } from 'lucide-react'

import { CONTROLS } from '@brickup/shared/locales/de/controls'
import { Button } from '@/components/base'
import { useIsDarkTheme } from '@/hooks/use-is-dark-theme'
import { useThemeStore } from '@/stores/use-theme-store'

/**
 * Light or dark, for the row of global controls.
 *
 * Named after what pressing it does, not after what is on screen: the icon and
 * the tooltip both show the theme it switches to. Until it is pressed the app
 * follows the operating system — the switch only ever adds a choice, it does
 * not have a third state to explain.
 *
 * @single-use one of the global controls, mounted once by the page header
 */
export function ThemeSwitch() {
  const setTheme = useThemeStore(state => state.setTheme)
  const isDark = useIsDarkTheme()
  const target = isDark ? 'light' : 'dark'
  const label = isDark ? CONTROLS.theme.toLight : CONTROLS.theme.toDark

  return (
    <Button
      tooltip={label}
      variant="ghost"
      size="icon"
      onClick={() => setTheme(target)}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </Button>
  )
}
